/* eslint-disable */
(function () {
    'use strict';
    angular.module('tmx-app').controller('accountOpeningApplicationEditCtrl', ['$scope', 'ENV', '$timeout', '$q', 'dynamicFormService', 'resolvedData', 'LoanApplicationService', 'AccountApplicationService',
        'tmxUtility', '$state', '$window', '$stateParams', "$mdDialog", 'lookupService', 'cacheStore', 'tmxResource', 'ToastService', 'BroadcastService', '$http', 'TMX_FINANCE_CONSTANTS', AccountOpeningApplicationEditCtrl]);
    var exists;
    var copy;
    var responseStatus;
    var STATUS = {
        NEW: "New",
        UNKNOWN: "Unknown",
        DRAFT: "Draft"
    };


    function AccountOpeningApplicationEditCtrl($scope, ENV, $timeout, $q, df, resolvedData, las, AccountApplicationService, tmxUtility, $state, $window, $stateParams, $mdDialog, lookupService, cacheStore, tmxResource, ToastService, BroadcastService, $http, TMX_FINANCE_CONSTANTS) {
        var vm = this;
        var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
        df.params.pageLoadComplete = false;
        vm.id = $stateParams.Id;
        vm.istabDisabled = false;
        exists = tmxUtility.exists;
        copy = tmxUtility.copy;
        vm.tmxResource = tmxResource;

        //initializing Lookup types from Tmx Finance Constant
        var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


        vm.statuses = lookupService.getLocalLookupsByType(lkupType.APPLICATION_STATUS);
        vm.isPageLoading = false;
        vm.showCommentDialog = showCommentDialog;
        vm.showManualDeviationDialog = showManualDeviationDialog;
        vm.showEvaluationRulesDialog = showEvaluationRulesDialog;
        vm.applicationStatus = "UnKnown";
        vm.status = "Unknwon";
        vm.df = df;
        vm.checkPermission = tmxUtility.checkPermission;
        vm.useTemplatePdf = false;
        vm.disableL1Button = true;
        vm.disableL2Button = true;
        vm.disbaleL2AgentButton = true;
        vm.disableField = true;
        vm.showActionsButton=false;
        vm.showDownloadButton=true; //default
      
        vm.resetPermission=vm.checkPermission('Account Application Reset Button');
        vm.savePermission=vm.checkPermission('Account Application Save Button');

        vm.actionButtons = {
            "ValidateEntity":false,
            "OpenAccount":false,
            "OpenL2Account":false,
            "OpenL2AgentAccount":false,
            "CheckChangesInCustomerMasterModel":false            
        };
             

        function setupActionButtons(){
            vm.actionButtons['ValidateEntity'] = vm.checkPermission('Validate Service', 'View') && vm.showFunctionalButton();
            vm.actionButtons['OpenAccount'] = vm.checkPermission('Show L0', 'View') && !vm.disableField;
            vm.actionButtons['OpenL2Account'] = vm.checkPermission('L2 Account Opening', 'View') && !vm.disableField;
            vm.actionButtons['OpenL2AgentAccount'] = vm.checkPermission('Show L2Agent', 'View') && !vm.disableField;
            vm.actionButtons['CheckChangesInCustomerMasterModel'] = vm.checkPermission('ETB Detect Changes');

           vm.showActionsButton=Object.keys(vm.actionButtons).some(key => vm.actionButtons[key]==true);;
        
        }


        var allFields = [];
        var objectToIterage = [];
        var rootKeys = [];
        var objectKeys = [];
        var keyThatAreActuallyObject = ["TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson"];
        var objectToArray = [];
        var openPdfInNewTab;
        vm.enableGetChangesButton = resolvedData.responseData.accountApplicationData.data.TmxCustomerMaster[0].IsModified && resolvedData.responseData.accountApplicationData.data.TmxCustomerMaster[0].ETBFlag;
        vm.errorControl = {
            watch: true,//switch to start watching(updates dynamically)
            show: true,//switch to show errors (red red kerdy ga har jagah :3)
            enable: true,//gloabl switch to turn on and of validation checkings
            validations: {//object to operate each validation individually
                required: true,//only for new loan app and draft loan app, required checking must be disabled
                maxlength: true,
                minlength: true
            }
        };
        vm.peripherals = {
            mustFields: [],//fields that must be filled irresepective of state of loan app
            locals: {}
        }
        vm.errorType = 'dynamic';// two types of errors, dynamic: that resolve dynamically. static: that do not resolve dynmically. They stay on screen until submission.
        vm.bizRulesFailedFields = [];//none of the fields have biz rule violations at begining
        var LoggedInTenant = "";
        var LoggedInUserConfigurations = cacheStore.get("Configurations");

        ////////////////// Scope Functions 

        var tenantName = "";
        function getLoggedInTenantDetail() {
            if (LoggedInUserConfigurations) {
                LoggedInTenant = LoggedInUserConfigurations.filter(function (item) {
                    return item.ConfigurationKey == 'INTEGRATION_TENANT';
                })[0];
            }
            tenantName = LoggedInTenant.ConfigurationValue ? LoggedInTenant.ConfigurationValue.toLowerCase() : "";
        }


        vm.enableUpdate = function () {
            var status = getStatus();
            return status != "Overdue" && status != "Active" && status != "Approved";
        }

        vm.replaceUnderscoresWithSpaces = function (value) {
            return value.replace(/_/g, " ");
        }

        vm.downloadPDF = function () {
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);

            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy);
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();

            var templates = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ACCOUNT_APP_PDF_TYPES);
            var templateToDownload = { templateName: 'Account_Application_HTML', pdfName: 'Account Application.pdf' };
            if (exists(templates) && templates.length > 0) // Go in this case to set templates if there are value in lookups else use default values as defined above
            {
                if (templates.length == 1) {
                    templateToDownload = {
                        templateName: templates[0].HiddenValue,
                        pdfName: templates[0].VisibleValue
                    }
                }
                else {
                    showTemplateSelectionDialog(templates, function (selectedTemplate) {
                        if (!exists(selectedTemplate)) {
                            return;
                        }
                        templateToDownload = {
                            templateName: selectedTemplate.HiddenValue,
                            pdfName: selectedTemplate.VisibleValue
                        };
                        $http.put(APP_CONSTANTS.backend + 'AccountApplication/DownloadAccountApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                            var file = new Blob([data], { type: 'application/pdf' });
                            saveOrDownloadPDF(file, templateToDownload.pdfName);
                        });
                    }, function () { });

                    return; /// return from original function
                }
            }

            $http.put(APP_CONSTANTS.backend + 'AccountApplication/DownloadAccountApplicationPDF/' + templateToDownload.templateName, vm.ResourceCopy, { responseType: 'arraybuffer' }).success(function (data) {
                var file = new Blob([data], { type: 'application/pdf' });
                saveOrDownloadPDF(file, templateToDownload.pdfName);
            });
        }

        function saveOrDownloadPDF(file, pdfName) {
            if (openPdfInNewTab) {
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL)
            }
            else{
                saveAs(file, pdfName);
            }

        }



        // vm.pageInitialization();          


        ///////////////// SETTING READONLY BASED ON DATA.INFO FROM $STATE paramter passed in from parent state/////////////////
        //----------------------------------------Functions---------------------------------------------------
        vm.showSimpleDialog = function (title, message, callback) {
            var alertConfig = {
                title: title,
                htmlContent: message,
                ok: 'Close'
            };
            var alert = $mdDialog.alert(alertConfig);
            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                    if (exists(callback)) callback();
                });
        }

        vm.validateEntity = function () {
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);
            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy, 'TmxCompanyBranch');
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();

            tmxResource("Integration").getByAction("ValidateAccountEntity", false, 'post', vm.ResourceCopy).then(function (response) {
                if (!exists(response)) {
                    ToastService.showCustomToast("default", "Error in calling the service");
                    return;
                }
                if (response.status.code == 200) {
                    if (response.data.Success == true) {
                        vm.disableActionButton1 = false;
                        ToastService.showCustomToast("success", "Validation successful.");

                    }
                    else {
                        var validationText = "";
                        if (exists(response.data) && response.data.Errors.length > 0) {
                            response.data.Errors.forEach(function (val) {
                                validationText += val + "<br>";
                            });
                        }
                        vm.showSimpleDialog("Validation Rules", validationText);
                    }
                }
                else {
                    ToastService.showCustomToast("default", response.status.message);
                }
            });

        }

        vm.saveAndLeave = function ($event) {
            vm.isPageLoading = true;
            vm.errorControl.validations.required = false;
            removeViolatedBizRules();
            vm.errorType = 'dynamic';
            vm.save(function () {
                vm.isPageLoading = false;
                loadData(vm.resource, true);
                //   if (responseStatus != "error" && responseStatus != "")
                //     vm.goto(vm.returnState);
                // });
            });
        }

        vm.save = function (callback) {
            if (exists(vm.page)) {
                var fillManadtory = getStatus() == STATUS.NEW || getStatus() == STATUS.DRAFT;


                vm.ResourceCopy = angular.copy(vm.resource);
                vm.page.write(vm.ResourceCopy, fillManadtory);
                unwrapLoanApplicationAttributes(vm.ResourceCopy);

                verifyPage();
                if (!vm.page.isValid) {
                    vm.isPageLoading = false;
                    var alert = {
                        title: 'Save Failed Due To Invalid Fields',
                        message: 'Application could not proceed to save due to some invalid fields. Please rectify the invalid fields in order to be able to save the Application.',
                    };
                    vm.showSimpleDialog(alert.title, alert.message);
                    return;//don't proceed with saving
                }

                //Loanapp ID fix
                if (!exists(vm.ResourceCopy.AccountApplicationId)) {
                    vm.ResourceCopy.AccountApplicationId = 0;
                }

                // var ImagesArray = angular.copy(vm.ResourceCopy.TmxLoanApplicationChecklist);

                vm.mapresource();
                vm.bindRootObjectsToChildObjects();
                makeArrayToObject(vm.ResourceCopy);
                vm.deleteEmptyObjects();
                objectCleaning(vm.ResourceCopy);
                setLoanApplicationChecklist();
                vm.ResourceCopy.$saveOrUpdate().then(function (response) {
                    if(!response || response.status < 0){ // In case of network error
                        vm.isPageLoading = false;
                        ToastService.showCustomToast("default", "Application saving failed, no response received from server.");
                        return;
                    }
                    if (response.status > 200) {
                        vm.isPageLoading = false;
                        if(response.status > 500){
                            ToastService.showCustomToast("default", "Application saving failed, an error occurred on server.");
                        }
                        else {
                            ToastService.showCustomToast("default", "Application saving failed.");
                        }
                        console.error("Error in saving application, response from server: ",response);
                        return;
                    }
                    
                    vm.resource = response.data;

                    // ImagesArray.forEach(function (item) {
                    //   if (item.Attachment != null && item.Attachment != "") {

                    //     item.MimeType = "";
                    //     if (item.Attachment.includes('data:image/jpeg;base64')) {
                    //       item.MimeType = "image\/png";
                    //     }
                    //     else if (item.Attachment.includes('data:application/pdf;base64')) {
                    //       item.MimeType = "application\/pdf";
                    //     }
                    //     else if (item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                    //       item.MimeType = "application\/xlsx";
                    //     }
                    //     item.Attachment = item.Attachment.replace('data:image/jpeg;base64,', '');
                    //     item.Attachment = item.Attachment.replace('data:application/pdf;base64,', '');
                    //     item.Attachment = item.Attachment.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');


                    //     var obj = {
                    //       LoanApplicationChecklistId: vm.findAccountApplicationChecklistId(item.LoanProductChecklistId, response.data.TmxLoanApplicationChecklist),
                    //       AttachmentURL: item.AttachmentURL == null || item.AttachmentURL == "" ? "Dummy Attachment URL" : item.AttachmentURL,
                    //       FileData: item.Attachment,
                    //       ImageData: "Empty Image Data",
                    //       LoanProductChecklistId: item.LoanProductChecklistId,
                    //       MimeType: item.MimeType
                    //     };

                    //     las.postImage(obj);
                    //   }
                    // });


                    var responseStatusCode = response.status.code != undefined ? response.status.code : response.status;
                    vm.saveSuccess = responseStatusCode;
                    if (exists(response)) {
                        switch (responseStatusCode) {
                            case 200:
                            case 201:
                            case 202:
                                responseStatus = "success";
                                break;
                            default:
                                responseStatus = "error";
                        }
                    }
                    else {
                        ToastService.showCustomToast("default", "Application saving failed due to unknown error");
                    }
                    callback();
                });
            }
        }

        vm.reset = function () {
            if (exists(vm.page) && exists(vm.accountApplicationData)) {
                vm.page.read(vm.accountApplicationData);
                $(".k-datetimepicker input").val('');
            }
        }

        vm.findAccountApplicationChecklistId = function (productId, TmxLoanApplicationChecklist) {
            var LoanApplicationChecklistId = null;
            TmxLoanApplicationChecklist.forEach(function (dataItem) {
                if (productId == dataItem.LoanProductChecklistId)
                    LoanApplicationChecklistId = dataItem.LoanApplicationChecklistId;
            })
            return LoanApplicationChecklistId;
        }


        vm.bindRootObjectsToChildObjects = function () {

            rootKeys = Object.getOwnPropertyNames(vm.ResourceCopy);
            rootKeys = rootKeys.filter(function (item) {
                return item.includes(".");
            })
            rootKeys.forEach(item => {
                if (Object.prototype.toString.call(vm.ResourceCopy[item]) === "[object Object]" && vm.ResourceCopy[item].type) {
                    vm.ResourceCopy[item] = JSON.parse(kendo.stringify(vm.ResourceCopy[item]))
                }
                if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && objectKeys.indexOf(item) < 0 && !(keyThatAreActuallyObject.indexOf(item) > -1)) {

                    try {
                        /*jshint evil:true */
                        eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item]");
                    }
                    catch (exception) {
                        console.log('Error Occured In Evaluating ' + item);
                    }
                }
                else if (Object.prototype.toString.call(vm.ResourceCopy[item]) === '[object Array]' && (objectKeys.indexOf(item) > 0 || keyThatAreActuallyObject.indexOf(item) > -1)) {
                    if (vm.ResourceCopy[item][0]) {
                        try {
                            /*jshint evil:true */
                            eval("vm.ResourceCopy." + item + " = vm.ResourceCopy[item][0]");
                        }
                        catch (exception) {
                            console.log('Error Occured In Evaluating ' + item);
                        }
                    }
                }
            });
        }
        vm.deleteEmptyObjects = function () {

            rootKeys.forEach(function (item) {
                delete vm.ResourceCopy[item];
            });
        }

        vm.mapresource = function () {
            vm.ResourceCopy.TmxLoanApplicationToGuarantorMapping = vm.accountApplicationData.TmxLoanApplicationToGuarantorMapping;
            vm.ResourceCopy.TmxCustomerMaster[0].negarea = vm.accountApplicationData.TmxCustomerMaster[0].negarea;
            vm.ResourceCopy.TmxCustomerMaster[0].negcustomer = vm.accountApplicationData.TmxCustomerMaster[0].negcustomer;
            // if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) && angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0]) && angular.isDefined(vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail) && angular.isDefined(vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0])) {
            //   vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness = vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NatureOfBusiness;
            //   vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer = vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonProfessionDetail[0].NameOfEmployer;
            // }
            vm.ResourceCopy.TmxCustomerMaster[0].FRMUStatus = vm.accountApplicationData.TmxCustomerMaster[0].FRMUStatus;
            vm.ResourceCopy.TmxCustomerMaster[0].SLSStatus = vm.accountApplicationData.TmxCustomerMaster[0].SLSStatus;
            vm.ResourceCopy.TmxCustomerMaster[0].PerAddressLine3UDF = vm.accountApplicationData.TmxCustomerMaster[0].PerAddressLine3UDF;

            var data = lookupService.getLocalLookupsByType(lkupType.ID_TYPE)
            if (data) {
                data.filter(function (item) {
                    if (item.VisibleValue == "NIC Number (ID-N)")
                        vm.cnicLookupId = item.LookupId;
                });
            }

            if (vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0] && vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson) {
                vm.cnicData = vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                    return item.NationalIdTypeLkp == vm.cnicLookupId
                })[0];

                if (angular.isDefined(vm.cnicData)) {
                    vm.cnic = vm.cnicData.NationalIdentifierValue;
                }
                if (angular.isDefined(vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier)) {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier.filter(function (item) {
                        if (item.NationalIDTypeLkp == vm.cnicLookupId)
                            item.NationalIdentifierValue = vm.cnic;
                    });
                }
                else {
                    vm.ResourceCopy.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier = vm.accountApplicationData.TmxCustomerMaster[0].TmxCustomerDetail[0].TmxPerson.TmxPersonNationalIdentifier
                }
            }
        }

        vm.submitCommand = function (command, ev) {
            vm.errorControl.validations.required = true;
            //remove any biz rules invalidations if any..
            removeViolatedBizRules();
            vm.errorType = 'dynamic';//set error type back to dynamic 
            verifyPage();
            $timeout(function () { // To get UI hook
                if (!vm.page.isValid) {
                    vm.isPageLoading = false;
                    var alert = {
                        title: 'Action Failed Due To Invalid Fields',
                        message: 'Application could not proceed to submit due to some invalid fields. Please rectify the invalid fields in order to be able to submit the Application.',
                    };
                    vm.showSimpleDialog(alert.title, alert.message);
                    return;//don't proceed with submitting
                }

                showCommentDialog(command, ev);
                return;
            }, 500);
        }

        vm.showEcibDialog = function ($scope) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'LoanApplicationService', EcibDialogController],
                templateUrl: 'app/private/transaction/loan-application/edit/ecib-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true, // Only for -xs, -sm breakpoints.
            }).then(function (data) {

            });

        }

        vm.GetChangesInCustomerMasterModel = function () {

            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);

            tmxResource("Integration").getByAction("CheckChangesInModel", true, 'post', vm.ResourceCopy.TmxCustomerMaster).then(function (response) {
                if (!response.data) {
                    response.data = [];
                }
                showFieldChangesDialog(response.data);
            });
        }


        function showFieldChangesDialog(data) {
            $mdDialog.show({
                controller: FieldChangesDialogCtrl,
                templateUrl: 'app/private/transaction/account-opening-application/field-change-dialog.html',
                parent: angular.element(document.body),
                locals: {
                    changesData: data
                },
                clickOutsideToClose: true,
                fullscreen: true,
            })
                .then(function (answer) {

                }, function () {

                });
        }

        function showTemplateSelectionDialog(data, successcb, errorcb) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'data', TemplateSelectionDialogCtrl],
                templateUrl: 'app/private/transaction/pdf-template-selection-dialog.html',
                parent: angular.element(document.body),
                locals: {
                    data: data
                },
                clickOutsideToClose: true,
                fullscreen: true,
            })
                .then(function (templateObj) {
                    successcb(templateObj)
                }, function () {
                    errorcb();
                });
        }

        function FieldChangesDialogCtrl($scope, $mdDialog, changesData) {
            $scope.changesData = changesData;
            $scope.done = function () {
                $mdDialog.hide();
            }
            $scope.cancel = function () {
                $mdDialog.hide();
            }
        }

        function TemplateSelectionDialogCtrl($scope, $mdDialog, data) {
            $scope.templateLookups = data;
            $scope.selectedTemplateId = null;
            var selectedTemplate = $scope.templateLookups[0];
            $scope.done = function () {
                if ($scope.selectedTemplateId != null && $scope.selectedTemplateId != undefined) {
                    selectedTemplate = $scope.templateLookups.find(x => x.LookupId == $scope.selectedTemplateId);
                    $mdDialog.hide(selectedTemplate);
                }
            }
            $scope.cancel = function () {
                $mdDialog.hide();
            }
        }

        vm.showFunctionalButton = function () {
            if (vm.resource.Commands && vm.resource.Commands.length > 0) {
                vm.istabDisabled = false;
                return true;
            }
            else {
                vm.istabDisabled = true;
                return false;
            }
        }
        vm.goto = function (state) {

            if (angular.isDefined(state)) {
                $state.searchClear = true;
                $state.go("private.inbox");
            }
            else {
                $state.searchClear = true;
                $state.reload($state.current);
            }
        }


        vm.isNew = function () {
            return getStatus() == STATUS.NEW;
        }

        vm.print = function (ev) {
            if (exists(vm.page)) {
                if (exists(vm.resource) && exists(vm.resource.TmxCustomerMaster) && exists(vm.resource.TmxCustomerMaster[0])) {
                    var CustomerMasterId = vm.resource.TmxCustomerMaster[0].CustomerMasterId;
                    var CustomerName = vm.resource.TmxCustomerMaster[0].CustomerName;
                }
                if (exists(vm.resource) && exists(vm.resource.TmxProduct) && exists(vm.resource.TmxProduct[0]) && angular.isDefined(vm.resource.TmxProduct[0].ProductName)) {
                    var ProductName = vm.resource.TmxProduct[0].ProductName;
                    var ProductId = vm.resource.TmxProduct[0].ProductId;
                }

                $mdDialog.show({
                    controller: 'PrintCtrl',
                    templateUrl: 'app/private/transaction/loan-application/edit/Print.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    locals: {
                        page: angular.copy(vm.page),
                        data: vm.resource,
                        CustomerId: CustomerMasterId,
                        ProductName: ProductName,
                        ProductId: ProductId,
                        CustomerName: CustomerName,
                        getVisibleValue: vm.getVisibleValue,
                        signatureCaptured: vm.signatureCaptured,
                        loanApplicationData: vm.loanApplicationData
                    },
                    clickOutsideToClose: true,
                    fullscreen: true,
                })
                    .then(function (answer) {

                    }, function () {

                    });

            }
        }

        //////////////////Scope Functions End

        ////////////////// Normal Functions 

        function setLoanApplicationChecklist() {
            vm.ResourceCopy.TmxLoanApplicationChecklist.forEach(function (item) {
                if (item.Attachment) {
                    item.MimeType = "";
                    if (item.Attachment.includes('data:image/jpeg;base64')|| item.Attachment.includes('data:image/png;base64')) {
                        item.MimeType = "image\/png";
                    }
                    else if (item.Attachment.includes('data:application/pdf;base64')) {
                        item.MimeType = "application\/pdf";
                    }
                    else if (item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                        item.MimeType = "application\/xlsx";
                    }
                    else if (item.Attachment.includes('data:image/tiff;base64')) {
                        item.MimeType = "image\/tiff";
                    }
                    else if (item.Attachment.includes('data:application/msword;base64') || item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64')) {
                        item.MimeType = "application/msword";
                    }
                    let metadataIdx = item.Attachment.indexOf(';base64,')
                    item.Attachment = item.Attachment.substring(metadataIdx + 8);
                    //item.Attachment = item.Attachment.replace('data:image/jpeg;base64,', '').replace('data:application/pdf;base64,', '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '').replace('data:image/tiff;base64,', '');
                }
            });
        }

        function registerMandatoryFields() {
            vm.fillManadtory = getStatus() == STATUS.NEW || getStatus() == STATUS.DRAFT;// must be true for a new loan app or one in draft stage.
            vm.errorControl.validations.required = !vm.fillManadtory;
        }

        function setupValidations() {
            switch (getStatus()) {
                case STATUS.NEW:
                case STATUS.DRAFT:
                    vm.peripherals.mustFields.forEach(function (id) {
                        var field = vm.page.fieldMap.primaryKey["tf" + id];
                        if (exists(field)) {//if the must field exists
                            field.errorControl = {
                                watch: true,//switch to start watching(updates dynamically)
                                show: true,//switch to show errors (red red kerdy ga har jagah :3)
                                enable: true,//gloabl switch to turn on and of validation checkings
                                validations: {//object to operate each validation individually
                                    required: true,
                                    maxlength: true,
                                    minlength: true
                                }
                            }
                        }
                    });
                    verifyPage();
                    break;
                default:
                    break;
            }
        }

        function loadData(responseAccountApplicationData, skipPageSchemaReload) {
            objectToArray = [];
            if (exists(resolvedData, "responseData.pageSchema.data")) {
                vm.pageSchema = resolvedData.responseData.pageSchema.data;

                tfsManipulation(vm.pageSchema[0]);
                df.pageSchema = vm.pageSchema[0]; 
                var status = null;
                if (exists(responseAccountApplicationData)) {
                    vm.applicationStatus = vm.statuses.find(function (item) { return item.LookupId == responseAccountApplicationData.ApplicationStatusLkp });
                    if (exists(status)) {
                        vm.applicationStatus = status.VisibleValue;
                    }
                }
                if (!skipPageSchemaReload) {
                    vm.page = df.loadPage(vm.pageSchema[0], undefined, vm.errorControl, vm.peripherals);//load page from schema
                    vm.page.registerDependants();
                }
                var selectedTab = exists(vm.page, "selectedTab") ? vm.page.selectedTab : undefined;

                if (exists(selectedTab) && selectedTab > 0) {
                    vm.page.selectedTabIndex = vm.page.tabs.findIndex(tab => tab.id == selectedTab);

                    if (vm.page.selectedTabIndex == 0) { // chosoy: 0th tab was appearing collapsed
                        $timeout(function () {
                            vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                            vm.page.selectedTab = selectedTab;
                        });
                    }
                    else { // No timeout in this section to avoid glitch
                        vm.page.tabs[vm.page.selectedTabIndex].isSelected = true;
                        vm.page.selectedTab = selectedTab;
                    }
                }

                // if (true) {
                // vm.accountApplicationData = resolvedData.responseData.accountApplicationData.data;
                vm.accountApplicationData = responseAccountApplicationData;
                wrapLoanApplicationAttributes(vm.accountApplicationData);

                if (vm.accountApplicationData["TmxCustomerMaster"]) {
                    takeOutChild(vm.accountApplicationData, vm.accountApplicationData.TmxCustomerMaster, 'TmxCustomerMaster');
                }

                if (vm.accountApplicationData.TmxCompanyBranch) {
                    makeObjectToArray(vm.accountApplicationData, 'TmxCompanyBranch');
                }


                vm.page.read(vm.accountApplicationData, vm.page.fieldMap);// fill the page object with initial loan application data
                //
                vm.commands = vm.accountApplicationData.Commands;
                if (exists(vm.commands))
                    vm.commands.forEach(function (command) { command.label = formatName(command.VisibleValue) });//format commands if any
                // } 
                // else {
                //   vm.accountApplicationData = new AccountApplicationService();
                // }
            }

            vm.resource = copy(vm.accountApplicationData);//vm.resource is the object we send to server for saving
            df.applicationData = vm.resource;
            df.params.pageLoadComplete = true;
        }

        function populateConfigurations() {
            if (LoggedInUserConfigurations) {
                vm.useTemplatePdf = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'USE_TEMPLATE_PDF', true);
                openPdfInNewTab = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'OPEN_PDF_WINDOW', true) || false;
            }
        }

        function registerRedirecting() {
            if (exists($stateParams.callbackState))//page to return to when leaving this screen
            {
                vm.returnState = $stateParams.callbackState;
            }
            else {
                vm.returnState = "^";//if nothing specified, move to parent state
            }
        }

        function setupCommandButtons(applicationData) {
            if (tmxUtility.checkPermission('Validate Service', 'View')) {
                if (TenantsList.VITAS == tenantName) {
                    vm.disableActionButton1 = true;
                    vm.disableActionButton2 = true;
                }
                else if (TenantsList.SAMBA == tenantName) {
                    vm.disableActionButton1 = true;
                }
            }
            vm.showDownloadButton = tmxUtility.checkPermission('Download PDF Button', 'View');

            handleCommandWiseCases();
        }

        function handleCommandWiseCases() {
            vm.commands.forEach(command => {
                if (command.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.AssignToMe) {
                    command.alwaysEnable = true;
                }
                else {
                    command.alwaysEnable = false;
                }
            });
        }

        function formatName(name) {
            var arr = name.split(/(?=[A-Z])/);
            var result = "";
            arr.forEach(function (token, index) {
                result += token;
                if (index < arr.length - 1) {
                    result += " ";
                }
            });
            return result;
        }


        function wrapLoanApplicationAttributes(resource) {
            resource.TmxAccountApplication = [];
            resource.TmxAccountApplication[0] = {};
            for (var key in resource) {
                if (resource.hasOwnProperty(key)) {
                    if (Object.prototype.toString.call(resource[key]) !== '[object Array]' && Object.prototype.toString.call(resource[key]) !== '[object Object]') {
                        resource.TmxAccountApplication[0][key] = resource[key];
                    }

                }
            }
        }

        function unwrapLoanApplicationAttributes(resource) {
            if (resource.TmxAccountApplication[0]) {
                var insideAttributes = Object.getOwnPropertyNames(resource.TmxAccountApplication[0]);
                insideAttributes.forEach(item => {
                    resource[item] = resource.TmxAccountApplication[0][item];
                });
            }
        }

        function makeObjectToArray(rootObject, obj) {

            Object.keys(rootObject).forEach(function (key) {
                if (Object.prototype.toString.call(rootObject[key]) == '[object Object]') {
                    objectToArray.push(key);
                    var tempObj = angular.copy(rootObject[key]);
                    rootObject[key] = [];
                    rootObject[key][0] = tempObj;
                }
            });

        }

        function makeArrayToObject(rootObject) {
            objectToArray.forEach(function (key) {
                if (Object.prototype.toString.call(rootObject[key]) == '[object Array]') {
                    var tempObj = angular.copy(rootObject[key][0]);
                    rootObject[key] = {};
                    rootObject[key] = tempObj;
                }
            });
        }

        function takeOutChild(rootObject, objectToTraverse, name = null) {

            var _self = this;

            if (!exists(objectKeys)) {
                objectKeys = [];
            }
            if (!exists(objectToTraverse)) return;
            if (Object.prototype.toString.call(objectToTraverse) == '[object Object]') {
                Object.keys(objectToTraverse).forEach(function (key) {
                    if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]' || Object.prototype.toString.call(objectToTraverse[key]) == '[object Array]') {
                        var rootObjectKey;
                        rootObjectKey = name + "." + key;

                        if (Object.prototype.toString.call(objectToTraverse[key]) == '[object Object]') {
                            rootObject[rootObjectKey] = [];
                            rootObject[rootObjectKey][0] = objectToTraverse[key];
                            if (objectKeys.indexOf(rootObjectKey) < 0) {
                                objectKeys.push(rootObjectKey)
                            }
                        }
                        else {
                            rootObject[rootObjectKey] = objectToTraverse[key];
                        }
                        takeOutChild(rootObject, objectToTraverse[key], rootObjectKey);
                    }
                });
            }
            else if (Object.prototype.toString.call(objectToTraverse) == '[object Array]') {
                for (var i = 0; i < objectToTraverse.length; i++) {
                    takeOutChild(rootObject, objectToTraverse[i], name + "[" + i + "]");
                }
            }
        }


        function objectCleaning(resourceObject) {

            var Obj = resourceObject

            Object.keys(Obj).forEach(function (objectKey) {
                if (Object.prototype.toString.call(Obj[objectKey]) == '[object Array]') {
                    Obj[objectKey].forEach(function (innerObject, index) {

                        for (var key in innerObject) {
                            if (!angular.isDefined(innerObject[key])) {
                                delete innerObject[key];
                            }
                        }

                        if (Object.getOwnPropertyNames(innerObject).length < 1) {
                            Obj[objectKey].splice(index, 1);
                        }
                        else {
                            objectCleaning(innerObject);
                        }
                    })
                }
            })
        }
        function tfsManipulation(tfsObject) {
            var allFields = [];
            // angular.forEach(tfsObject.Tabs, function (item, key) {
            //     angular.forEach(item.Fields, function (obj, key) {
            //         allFields.push(obj)
            //     })
            // });
            function extractFields(tab){
                if(exists(tab.Tabs) && tab.Tabs.length > 0){ // if there are sub tabs
                    tab.Tabs.forEach(extractFields);
                }
                angular.forEach(tab.Fields, function (obj, key) {
                    allFields.push(obj)
                });
            }

            tfsObject.Tabs.forEach(extractFields);

            objectToIterage = angular.copy(allFields);

            angular.forEach(allFields, function (item, key) {
                if (!item.FieldTableName.includes('.')) {
                    try {
                        item.FieldTableName = renameTableName(item);
                    }
                    catch (e) {
                        console.error(e);
                        console.error('Error in field definition', item);
                    }
                }
            })
        }

        function renameTableName(item) {
            var newParentId = 0;
            var fieldTableName = item.FieldTableName;

            if (item._ParentFieldId) {
                newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0]._ParentFieldId;
                if (objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.includes('[]')) {
                    var tableName = angular.copy(objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName.replace('[]', ''));
                    fieldTableName = tableName + '[0].' + item.FieldTableName.replace('[]', '');
                }
                else {
                    fieldTableName = objectToIterage.filter(obj => obj.TenantFieldSetupId == item._ParentFieldId)[0].FieldTableName + '.' + item.FieldTableName.replace('[]', '');
                }
            }

            while (newParentId) {
                fieldTableName = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0].FieldName + '[0].' + fieldTableName;
                newParentId = objectToIterage.filter(obj => obj.TenantFieldSetupId == newParentId)[0]._ParentFieldId
            }


            var FinalName = fieldTableName.replace('TmxAccountApplication[0].', '');
            FinalName = FinalName.replace('TmxAccountApplication.', '');

            return FinalName;
        }

        function getStatus() {
            var ret_status = STATUS.NEW;
            if (exists(vm.accountApplicationData.ApplicationStatusLkp) && exists(vm.resource.ApplicationStatusLkp)) {
                var status = vm.statuses.find(function (item) { return item.LookupId == vm.accountApplicationData.ApplicationStatusLkp });
                if (exists(status)) {
                    ret_status = status.VisibleValue;
                }
            }
            return ret_status;
        }

        function showEvaluationRulesDialog(evaluationData, showOnlyMessages) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'evaluationData', 'lookupService', 'UsersService', 'showOnlyMessages', 'tenantName', 'TenantsList', EvaluationRulesDialogController],
                locals: { evaluationData: evaluationData, showOnlyMessages: showOnlyMessages, tenantName: tenantName, TenantsList: TenantsList },
                templateUrl: 'app/private/transaction/loan-application/edit/evaluation-rule-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (responseData) {

                    if (responseData) {
                        vm.isPageLoading = true;
                        var ProcessInstanceID = vm.accountApplicationData.ProcessInstanceId;
                        var action = "ExecuteWf";
                        (function () {
                            var data = {
                                "Parameter": '',
                                "Command": 'DeviationApproval',
                                "TargetUserId": responseData.TargetUserId,
                                "rule": evaluationData.data,
                                "UserId": JSON.parse(localStorage.getItem("user")).Id,
                                "ProcessID": ProcessInstanceID,
                                "ApplicationId": vm.accountApplicationData.AccountApplicationId,
                                "TmxLoanApplicationRemark": responseData.TmxLoanApplicationRemark
                            }
                            AccountApplicationService.getByAction(action, true, "put", data).then(function () {
                                vm.isPageLoading = false;
                                $state.go("private.inbox");
                            });
                        })();
                    }
                }, function () {

                });
        }

        function EvaluationRulesDialogController($scope, $mdDialog, evaluationData, lookupService, UsersService, showOnlyMessages, tenantName, TenantsList) {

            $scope.vm = {};
            $scope.RulesList = [];
            $scope.showDeviationFields = false;
            $scope.showOnlyMessages = showOnlyMessages;
            $scope.TmxLoanApplicationRemark = [{
                "Comments": ""
            }];

            if (evaluationData.data && evaluationData.data != null) {
                for (var key in evaluationData.data) {
                    $scope.RulesList.push({
                        ruleKey: key.toUpperCase(),
                        ruleText: evaluationData.data[key]
                    });
                }
                if (evaluationData.data.manualDeviation || (evaluationData.data.warning && evaluationData.data.manualDeviation) || (evaluationData.data.error && evaluationData.data.manualDeviation)) {
                    $scope.showDeviationFields = true;
                }
                else if (evaluationData.data.error || evaluationData.data.warning || (evaluationData.data.error && evaluationData.data.warning)) {
                    $scope.showDeviationFields = false;
                }
            }
            else {
                if (evaluationData.manualDeviation || evaluationData.warning || evaluationData.error) {
                    Object.keys(evaluationData).forEach(function (key) {
                        $scope.RulesList.push({
                            ruleKey: key.toUpperCase(),
                            ruleText: evaluationData[key]
                        });
                    });
                    if (evaluationData.manualDeviation || (evaluationData.warning && evaluationData.manualDeviation) || (evaluationData.error && evaluationData.manualDeviation)) {
                        $scope.showDeviationFields = true;
                    }
                    else if (evaluationData.error || evaluationData.warning || (evaluationData.error && evaluationData.warning)) {
                        $scope.showDeviationFields = false;
                        if (evaluationData.error)
                            vm.status = "error";
                        else if (evaluationData.warning)
                            vm.status = "warning";
                    }
                }
            }

            $scope.ok = function () {
                $mdDialog.hide();
                if (vm.status == "warning" && !$scope.showOnlyMessages)
                    $state.go("private.inbox");
            };


            function getPropertyValueByHiddenValue(levelsList, hiddenValue, property) {
                var obj = levelsList.filter(function (item) {
                    return item.HiddenValue == hiddenValue;
                })[0]
                return obj[property];
            }

            lookupService.getByType('USER').then(function (data) {
                $scope.LevelsList = data;
                $scope.disableLevelList = false;
                if (TenantsList.SILK == tenantName) {
                    var deviationReceivedLevels = [];
                    var obj = $scope.RulesList.filter(function (item) {
                        return item.ruleKey == 'MANUALDEVIATION'
                    })[0];

                    if (obj && obj.ruleText) {
                        obj.ruleText.forEach(function (item) {
                            deviationReceivedLevels.push(
                                {
                                    name: item.split(':')[0],
                                    id: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'LookupId'),
                                    sort: getPropertyValueByHiddenValue($scope.LevelsList, item.split(':')[0], 'SortOrder')
                                }
                            )
                        })

                        if (deviationReceivedLevels.length > 0) {
                            deviationReceivedLevels.sort(function (a, b) { return a.sort - b.sort; });
                            $scope.vm.levelId = deviationReceivedLevels[0] ? deviationReceivedLevels[0].id : null;
                            $scope.levelChange($scope.vm.levelId);
                            $scope.disableLevelList = true;
                        }
                    }
                }
            });

            $scope.levelChange = function (typeId) {
                if (typeId) {
                    UsersService.getUsersByType(typeId).then(function (response) {
                        $scope.UsersList = response.data;

                    })
                }
                else {
                    $scope.vm.userId = null;
                    $scope.UsersList = [];
                }
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.done = function () {
                if ($scope.vm.userId) {
                    var responseData = {};
                    responseData.TmxLoanApplicationRemark = $scope.TmxLoanApplicationRemark;
                    responseData.TargetUserId = $scope.vm.userId;
                    $mdDialog.hide(responseData);
                }

            }
        }

        function showManualDeviationDialog(command, ParameterName, ev) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'lookupService', 'UsersService', ManualDeviationDialogController],
                templateUrl: 'app/private/transaction/loan-application/edit/manual-deviation-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (responseData) {
                    vm.isPageLoading = true;
                    var action = "action/" + vm.accountApplicationData.AccountApplicationId + "/" + command;
                    vm.save(function () {
                        vm.isPageLoading = false;
                        loadData(vm.resource);
                        var data = {
                            "Comment": responseData.comments,
                            "Parameter": ParameterName,
                            "TargetUserId": responseData.userId
                        }
                        AccountApplicationService.getByAction(action, true, "put", data).then(function (response) {
                            vm.isPageLoading = false;
                            if (response.data.status) {
                                if (response.data.status.code < 400) {
                                    $state.go("private.inbox");
                                }
                                else {
                                    showEvaluationRulesDialog(response.data.data);
                                }
                            }

                        });
                    });


                }, function () {

                });
        }

        function ManualDeviationDialogController($scope, $mdDialog, lookupService, UsersService) {
            $scope.UsersList = [];
            $scope.LevelsList = [];
            var data = {};

            lookupService.getByType('USER').then(function (data) {
                $scope.LevelsList = data;
            });
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.done = function () {
                if ($scope.userId) {
                    data.userId = $scope.userId;
                    data.comments = $scope.comments;
                    $mdDialog.hide(data);
                }
            };

            $scope.levelChange = function (typeId) {
                if (typeId) {
                    UsersService.getUsersByType(typeId).then(function (response) {
                        $scope.UsersList = response.data;

                    })
                }
                else {
                    $scope.userId = null;
                    $scope.UsersList = [];
                }
            }
        }

        function showCommentDialog(commandObj, ev) {
            let command = commandObj.HiddenValue;
            let ParameterName = commandObj.ParameterName;
            let receivingActors = commandObj.TmxWorkflowReceivingActor;

            var loggedInUserID = JSON.parse(localStorage.getItem("user")).Id;
            var AccountApplicationID = vm.accountApplicationData.AccountApplicationId;
            var ProcessInstanceID = vm.accountApplicationData.ProcessInstanceId;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', '$filter', 'tmxUtility', 'UsersService', 'ToastService', 'lookupService', 'TMX_FINANCE_CONSTANTS', 'command', 'Actors', 'UserId', 'ApplicationId', 'TenantName', CommentsDialogController],
                locals: { command: command, UserId: loggedInUserID, ApplicationId: AccountApplicationID, TenantName: tenantName, Actors: receivingActors },
                templateUrl: 'app/private/transaction/loan-application/edit/comment-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (responseData) {
                    vm.isPageLoading = true;
                    // var action = "action/" + vm.accountApplicationData.AccountApplicationId + "/" + command;
                    var action = "ExecuteWf";
                    vm.save(function (saveResponse) {
                        vm.isPageLoading = false;
                        loadData(vm.resource);
                        if (vm.saveSuccess >= 400) {
                            vm.isPageLoading = false;
                            return;
                        }

                        var data = {
                            "Parameter": ParameterName,
                            "Command": command,
                            "ProcessID": ProcessInstanceID,
                            "ApplicationId": AccountApplicationID,
                            "UserId": loggedInUserID,
                            "TmxLoanApplicationRemark": responseData.TmxLoanApplicationRemark,
                            "TmxWorkflowReceivingActor": responseData.TmxWorkflowReceivingActor
                        }

                        // var data = {
                        //   "Comment": responseData.comments,
                        //   "Parameter": ParameterName,
                        //   "RemarksLkp": responseData.Reason
                        // }
                        AccountApplicationService.getByAction(action, false, "put", data).then(function (response) {
                            vm.isPageLoading = false;
                            if (response.data && response.data != null) {
                                if (response.data.status != null && (response.data.status.code == 417 || response.data.code == 417)) {
                                    var validationText = "";
                                    if (exists(response.data.data) && exists(response.data.data.Errors) && response.data.data.Errors.length > 0) {
                                        validationText = prepareErrorText(response.data.data.Errors);
                                    }
                                    if (response.data.data.Errors) {
                                        vm.showSimpleDialog("Validation Rules", validationText);
                                    }

                                    if (response.data.data.model) {
                                        var tmxResource = vm.tmxResource('AccountApplication');
                                        vm.resource = tmxResource.createResourceObject(response.data.data.model);
                                        loadData(vm.resource);
                                    }

                                }
                                else if (response.data.manualDeviation || exists(response.data.data, 'manualDeviation')) {
                                    if (!exists(response.data.manualDeviation)) { // In some cases deviations is coming inside data so handling that case
                                        response.data.manualDeviation = response.data.data.manualDeviation;
                                    }
                                    showDeviationDialog(response);
                                }
                                else if (response.data.error || exists(response.data.data, 'error')) {
                                    if (!exists(response.data.error)) { // In some cases error is coming inside data so handling that case
                                        response.data.error = response.data.data.error;
                                    }
                                    showDeviationDialog(response);
                                }
                                else if (response.data.warning || exists(response.data.data, 'warning')) {
                                    if (!exists(response.data.warning)) { // In some cases warning is coming inside data so handling that case
                                        response.data.warning = response.data.data.warning;
                                    }
                                    showDeviationDialog(response);
                                }
                                else if (exists(response.data.wFDeviation) || exists(response.data.data, 'wFDeviation')) {
                                    if (!exists(response.data.wFDeviation)) { // In some cases wf deviations is coming inside data so handling that case
                                        response.data.wFDeviation = response.data.data.wFDeviation;
                                    }
                                    let validationText = "";
                                    if (exists(response.data.wFDeviation) && response.data.wFDeviation.length > 0) {
                                        response.data.wFDeviation.forEach(function (val, index) {
                                            validationText += index + 1 + ') ' + val + "<br>";
                                        });
                                    }
                                    vm.showSimpleDialog("WorkFlow Deviation(s)", validationText, function () {
                                        $state.go("private.inbox");
                                    });
                                }
                                else {
                                    $state.go("private.inbox");
                                }
                            }
                            else {
                                $state.go("private.inbox");
                            }
                        });
                    });

                }, function () {

                });
            function showDeviationDialog(response) {
                if (response.data && !exists(response.data.data)) {
                    var data = response.data;
                    response.data = {};
                    response.data.data = {};
                    response.data.data = data;
                }
                showEvaluationRulesDialog(response.data.data);
                df.applicationData = vm.resource;
                loadData(vm.resource);
            }
        }

        function prepareErrorText(errorList) {
            var validationText = "";
            if (Object.prototype.toString.call(errorList) === '[object Array]') {
                errorList.forEach(function (val) {
                    validationText += val + "<br>";
                });
            }
            else {
                validationText = errorList;
            }
            return validationText;
        }

        function CommentsDialogController($scope, $mdDialog, $filter, tmxUtility, UsersService, ToastService, lookupService, TMX_FINANCE_CONSTANTS, command, Actors, UserId, ApplicationId, TenantName) {
            $scope.TenantName = TenantName;
            $scope.RejectionReasonList = [];
            $scope.RoleActorList = Actors;
            $scope.isCommentMandatory = tmxUtility.getConfigurationValue(LoggedInUserConfigurations,'IS_SUBMISSION_COMMENT_MANDATORY',true);
            $scope.removeReason = function (index) {
                $scope.RejectionReasonList.splice(index, 1);
            }
            $scope.addReason = function () {

                $scope.RejectionReasonList.push(
                    {
                        "Comments": "",
                        "RemarksLkp": 0,
                        "AccountApplicationId": ApplicationId,
                        "ActionType": null,
                        "UserId": UserId
                    });
            }
            $scope.addReason();

            $scope.command = command;
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.done = function (comments, Reason) {
                $scope.CommentsDialogController.dialogForm.$submitted = true;
                if (!$scope.CommentsDialogController.dialogForm.$valid) {
                    ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                    $scope.CommentsDialogController.dialogForm.$submitted = false;
                    return;
                }
                $scope.responseData = {};
                $scope.responseData.TmxLoanApplicationRemark = $scope.RejectionReasonList;
                if (tmxUtility.exists($scope.RoleActorList) && $scope.RoleActorList.length > 0) {
                    $scope.responseData.TmxWorkflowReceivingActor = [];
                    $scope.RoleActorList.forEach(actor => (
                        $scope.responseData.TmxWorkflowReceivingActor.push({ ActorRole: actor.HiddenValue, ActorId: actor.SelectedUser })
                    ));
                }
                // var data = {
                //   comments: comments,
                //   Reason: Reason,
                // }
                $mdDialog.hide($scope.responseData);
            };

            //initializing Lookup types from Tmx Finance Constant
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
            function InitializeLookups() {
                $scope.lookups = {};
                lookupService.getLookupByType(lkupType.RejectionTypes).then(function (response) {
                    $scope.lookups.rejectionReasonLkp = response;
                });
                lookupService.getLookupByType(lkupType.CIU_REJECTION_CODES).then(function (response) {
                    $scope.lookups.rejectionCodesLkp = response;
                });
                lookupService.getLookupByType(lkupType.YES_NO).then(function (response) {
                    $scope.lookups.yesNoLkp = response;
                });
            }

            function PopulateRoleUserList() {
                if (tmxUtility.exists(Actors) && Actors.length > 0) {
                    var roleNames = Actors.map(x => x.ActorRole);
                    let roleNamesString = roleNames.join(',');
                    UsersService.getUserByRoleNames(roleNamesString).then(function (response) {
                        $scope.RoleActorList = [];
                        if (tmxUtility.exists(response, "status.code") || response.status.code == 200) {
                            roleNames.forEach(name => {
                                let roleListItem = { HiddenValue: name, VisibleValue: name };
                                roleListItem.UserList = response.data.filter(x => x.RoleName == name);
                                $scope.RoleActorList.push(roleListItem);
                            });
                        }
                        else {
                            ToastService.showCustomToast('error', 'Error in getting the users list.')
                            console.log("Error in fetching user list. Response received: ", response);
                        }
                    });
                }
            }

            (function InitializeDialogController() {
                InitializeLookups();
                PopulateRoleUserList();
            })();

        }


        function verifyPage() {
            vm.page.verify(function () {
            });
        }


        function removeViolatedBizRules() {
            vm.bizRulesFailedFields.forEach(function (field) {
                var bizRuleViolations = field.possibleValidations.all.filter(function (violation) { return violation.name.indexOf("bizRule") > -1; })
                bizRuleViolations.forEach(function (violation) {
                    field.removeValidationRule(violation.name);
                });
            });
            vm.bizRulesFailedFields = [];
        }

        (function PageLoad() {
            registerRedirecting();
            populateConfigurations();
            getLoggedInTenantDetail();
            loadData(resolvedData.responseData.accountApplicationData.data);
            registerMandatoryFields();
            setupValidations();
            setupCommandButtons();
            enableAccountCreationButton();
            setupActionButtons();
        }());

        function enableAccountCreationButton() {
            if (TenantsList.UBANK == tenantName) {
                vm.disableField = false;
                //L0 Button Visibility
                if (tmxUtility.checkPermission('Show L0', 'View')) {
                    vm.disableL1Button = false;
                }

                //L2 Button Visibility
                if (tmxUtility.checkPermission('L2 Account Opening', 'View')) {
                    vm.disableL2Button = false;
                }

                //L2 Agent Button Visibility
                if (tmxUtility.checkPermission('Show L2Agent', 'View')) {
                    vm.disbaleL2AgentButton = false;
                }

            }
        }

        //Open LO/L1 account
        vm.openL1Account = function () {
            vm.isPageLoading = true;
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);
            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy);
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();

            tmxResource("Integration").getByAction("L0L1AccountCreation", false, 'post', vm.ResourceCopy).then(function (response) {
                vm.isPageLoading = false;
                if (response != null && response.status != null && response.status.code == 200 && response.data != null && response.status.message == "Success" && response.data.accountAppVM != null) {
                    vm.resource = response.data.accountAppVM;
                    if (vm.resource) {
                        vm.loanApplicationData = angular.copy(vm.resource);
                        df.applicationData = vm.resource;
                        loadData(vm.resource);
                    }
                }
                else {
                    if (response != null && response.data != null) {
                        ToastService.showCustomToast('error', response.data.responseMessage)
                        return;
                    }
                    else if (response != null && response.status != null && response.status.code != 200) {
                        ToastService.showCustomToast('error', response.status.message)
                        return;
                    }
                }
            });
        }

        //Open L2 Account
        vm.openL2Account = function () {
            vm.isPageLoading = true;
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);
            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy);
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();

            tmxResource("Integration").getByAction("L2AccountCreation", false, 'post', vm.ResourceCopy).then(function (response) {
                vm.isPageLoading = false;
                if (response != null && response.status != null && response.status.code == 200 && response.data != null && response.status.message == "Success" && response.data.accountAppVM != null) {
                    vm.resource = response.data.accountAppVM;
                    if (vm.resource) {
                        vm.loanApplicationData = angular.copy(vm.resource);
                        df.applicationData = vm.resource;
                        loadData(vm.resource);
                    }
                }
                else {
                    if (response != null && response.data != null) {
                        ToastService.showCustomToast('error', response.data.responseMessage)
                        return;
                    }
                    else if (response != null && response.status != null && response.status.code != 200) {
                        ToastService.showCustomToast('error', response.status.message)
                        return;
                    }
                }
            });
        }

        //Open L2 Agent Account
        vm.openL2AgentAccount = function () {
            vm.isPageLoading = true;
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);
            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy);
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();

            tmxResource("Integration").getByAction("L2AgentRegistration", false, 'post', vm.ResourceCopy).then(function (response) {
                vm.isPageLoading = false;
                if (response != null && response.status != null && response.status.code == 200 && response.data != null && response.status.message == "Success" && response.data.accountAppVM != null) {
                    vm.resource = response.data.accountAppVM;
                    if (vm.resource) {
                        vm.loanApplicationData = angular.copy(vm.resource);
                        df.applicationData = vm.resource;
                        loadData(vm.resource);
                    }
                }
                else {
                    if (response != null && response.data != null) {
                        ToastService.showCustomToast('error', response.data.responseMessage)
                        return;
                    }
                    else if (response != null && response.status != null && response.status.code != 200) {
                        ToastService.showCustomToast('error', response.status.message)
                        return;
                    }
                }
            });
        }


        BroadcastService.subscribe("onGridDataFetch", $scope, function (evt, data) {

            vm.isPageLoading = true;
            var sourceTable = df.mapArray[data.src].table;
            var destinationTable = data.des;
            vm.ResourceCopy = angular.copy(vm.resource);
            vm.page.write(vm.ResourceCopy, false);
            unwrapLoanApplicationAttributes(vm.ResourceCopy);
            vm.mapresource();
            vm.bindRootObjectsToChildObjects();
            makeArrayToObject(vm.ResourceCopy);
            vm.deleteEmptyObjects();
            objectCleaning(vm.ResourceCopy);
            setLoanApplicationChecklist();
            eval('vm.ResourceCopy.' + destinationTable + ' = vm.ResourceCopy.' + sourceTable);
            loadData(vm.ResourceCopy);
            vm.isPageLoading = false;

        });


        function EcibDialogController($scope, $mdDialog, LoanApplicationService) {
            $scope.bankId = 2;
            $scope.bankNames = [];
            $scope.formatDate=tmxUtility.formatDateForCompany;
            LoanApplicationService.getEcibDetail().then(function (response) {
                $scope.ecibData = response.data.DBRData;
                if ($scope.ecibData[0]) {
                    $scope.ecibData[0].BankList.forEach(function (item, index) {
                        $scope.bankNames.push({
                            'VisibleValue': item,
                            'LookupId': index + 1
                        });
                    });
                }

            });

            $scope.addMoreEcib = function () {
                $scope.ecibData.push({
                    "MRDate": "",
                    "FDate": "",
                    "DBR": 0,
                    "AsOfDate": "",
                    "Balance": 0,
                    "Limit": 0,
                    "Product": $scope.ecibData.length,
                    "IsDefaulter": false,
                    "TermLoanOrEvergreen": "",
                    "TypeOfLoan": "",
                    "Base64PdfString": null,
                    "Bank": null,
                    "ProductName": ""
                })
            }

            $scope.removeEcib = function (index) {
                $scope.ecibData.splice(index);
            }

            $scope.branchChange = function () {
            }

            $scope.pdfUrl = "https://tlxfinance.blob.core.windows.net/images-qa/techx/3520268380749.pdf";

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };         
        }

        BroadcastService.subscribe('IsModifiedChange', $scope, function (evt, data) {
            if (vm.resource.TmxCustomerMaster[0].ETBFlag) {
                vm.enableGetChangesButton = true;
            }
        });

        vm.formChange = function () {
            if (TenantsList.VITAS == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                vm.disableActionButton1 = true;
                vm.disableActionButton2 = true;
            }
            else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                vm.disableActionButton1 = true;
            }
        }

        $scope.$on("SelectChangeEvent", function (evt, data) {
            if (TenantsList.VITAS == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                vm.disableActionButton1 = true;
                vm.disableActionButton2 = true;
            }
            else if (TenantsList.SAMBA == tenantName && tmxUtility.checkPermission('Validate Service', 'View')) {
                vm.disableActionButton1 = true;
            }
        });
    }
})();